import axios from "axios";
import { API_GET_USER_TYPE_DATA, API_INSERT_USER_TYPE_DATA, API_TOGGLE_USER_TYPE_DATA, API_UPDATE_USER_TYPE_DATA } from ".";

export const getUserTypesList = async (func, config) => {
    return axios.get(API_GET_USER_TYPE_DATA, config).then(res => func(res.data.data));
}

export const insertUserTypeData = async (data, config) => {
    return axios.post(API_INSERT_USER_TYPE_DATA, data, config).then((res) => res.data);
};

export const updateUserTypeData = async (data, config) => {
    return axios.put(API_UPDATE_USER_TYPE_DATA, data, config).then((res) => res.data);
};

export const toggleUserTypeData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_USER_TYPE_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};